import FormField from './formfield'

export default class ValidatedForm {
  public fields: { [key: string]: FormField } = {}

  constructor (formFields: { [key: string]: FormField }) {
    this.fields = formFields
  }

  public validateForm = () => {
    this.setDirty(true)
    return this.getFormValid()
  }

  public setDirty (dirty: boolean) {
    Object.values(this.fields).forEach((field) => { field.dirty = dirty })
  }

  public resetForm () {
    Object.values(this.fields).forEach((field) => { field.resetField() })
  }

  private getFormValid () {
    return Object.values(this.fields)
      .filter((field: FormField) => (field.validate() as string[]).length > 0).length === 0
  }
}
